/* DeleteAction.js */

"use strict";

const PLAN_NAME_MAX_LENGTH = 60;
const PLAN_NAME_LIST_LENGTH = 10;

class DeleteAction {
    constructor(logger, gameEditor, modalUserFeedback, activeView, userSession, ExplorerTemplate) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._hasModeratorAuth = userSession.authorizedActions.indexOf("explorerTemplateModerate") > 0;
        this._explorerTemplate = ExplorerTemplate;
        this._selectedPlanIds = [];
        this._selectedPlanNames = [];
        this._userId = this._gameEditor._userSession.user.id;

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedPlanIds = this._activeView.getSelectedPlanIds().selectedRows || [];
        }

        this.run = this.run.bind(this);
    }

    run() {
        if (this._selectedPlanIds.length) {
            let hasNonDeletableEntites = false;
            this._activeView.pagingFeed
                .waitForRangeIdsUpdated()
                .then(() => {
                    return this._activeView.pagingFeed._getTemplateEntitiesById(this._selectedPlanIds);
                })
                .then((selectedPlanEntities) => {
                    this._selectedPlanEntities = selectedPlanEntities || [];
                    if (Array.isArray(this._selectedPlanEntities)) {
                        if (this._selectedPlanEntities.length === 1) {
                            // if not same user or not same org throw error
                            if (this._selectedPlanEntities[0].ownerId !== this._userId && !this._hasModeratorAuth) {
                                throw new Error("You cannot delete another user's shared template.");
                            }
                            if (this._selectedPlanEntities[0]._tenantId !== this._activeOrgId) {
                                throw new Error("You cannot delete template from a different organization.");
                            }
                        } else {
                            this._selectedPlanIds = this._selectedPlanEntities
                                .filter((entity) => {
                                    if ((entity.ownerId !== this._userId && !this._hasModeratorAuth) || entity._tenantId !== this._activeOrgId) {
                                        return false;
                                    }
                                    return true;
                                })
                                .map((ety) => ety.id);

                            if (this._selectedPlanIds.length < this._selectedPlanEntities.length) {
                                hasNonDeletableEntites = true;
                            }
                        }
                    }
                    if (this._selectedPlanIds.length <= PLAN_NAME_LIST_LENGTH) {
                        return this._activeView.pagingFeed.getEntitiesNameById(this._selectedPlanIds).then((selectedPlanNames) => {
                            this._selectedPlanNames = selectedPlanNames;
                            if (Array.isArray(this._selectedPlanNames) && this._selectedPlanNames.length > 0) {
                                let s = this._selectedPlanNames.length > 1 ? "s" : "";
                                this._message = "Are you sure you want to permanently delete the selected template" + s + "?\n";
                                Object.keys(this._selectedPlanNames).forEach((id) => {
                                    let planName = this._selectedPlanNames[id];
                                    let shortPlanName =
                                        planName.length > PLAN_NAME_MAX_LENGTH ? planName.substr(0, PLAN_NAME_MAX_LENGTH) + "…" : planName;
                                    this._message += "\n" + shortPlanName;
                                });
                                if (hasNonDeletableEntites) {
                                    this._message +=
                                        "\n\n Templates created in other organizations or by other users cannot be deleted and have been removed from your selection.";
                                }
                                return Promise.resolve();
                            } else {
                                return Promise.reject(new Error("Cannot retrieve the selected template"));
                            }
                        });
                    } else {
                        this._message = `Are you sure you want to permanently delete the selected ${this._selectedPlanIds.length} template?\n`;
                        if (hasNonDeletableEntites) {
                            this._message +=
                                "\n\n Templates created in other organizations or by other users cannot be deleted and have been removed from your selection.";
                        }
                        return Promise.resolve();
                    }
                })
                .then(() => {
                    return this._gameEditor.runQuickConfirmationActionWorkflow(
                        {
                            message: this._message,
                            title: "Delete",
                            confirmDetails: {
                                text: "Confirm",
                                type: "destructive"
                            },
                            rejectDetails: {
                                text: "Cancel",
                                type: "text"
                            }
                        },
                        () => {
                            let workTarget = {
                                method: "multi",
                                ids: this._selectedPlanIds
                            };
                            const showProgFunc = (prog) => {
                                this._modalUserFeedback.showLoadingProgress(`${prog.successCount} of ${prog.targetCount}`);
                            };
                            return this._explorerTemplate
                                .runDeleteExplorerTemplatesWork(this._activeOrgId, workTarget, undefined, showProgFunc)
                                .then((workResults) => {
                                    this._explorerTemplate.throwWorkErrors(workResults);
                                    this._activeView.resetSelection();
                                    // if (
                                    //     this._activeView &&
                                    //     this._activeView.pagingFeed &&
                                    //     this._activeView.pagingFeed.feedUpdate
                                    // ) {
                                    //     // this._activeView.pagingFeed.feedUpdate();
                                    // }
                                    return Promise.resolve();
                                });
                        }
                    );
                })
                .catch((err) => {
                    this._logger.warn({ error: err }, "DeleteAction.run() - Error");
                    return this._modalUserFeedback.displayError({ error: { errorMsg: err } });
                });
        } else {
            return Promise.resolve();
        }
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.ExplorerTemplate"
];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    shown: true,
    title: "Delete templates",
    order: 5
};
